import { Button, Typography } from '@mui/material';
import { SHOW_FULL_INFORMATION, SHOW_LESS_DESCRIPTION } from 'pages/Valuations/util/constants';
import { COMPANY_DESCRIPTION_MAX_LENGTH } from './constants';
import useStyles from './styles';
import { CompanyDescriptionProps } from './types';

const CompanyDescription = ({
  description,
  truncate,
  toggleDescription,
  isCollapsible = false,
  maxCharsDisplay = COMPANY_DESCRIPTION_MAX_LENGTH,
}: CompanyDescriptionProps) => {
  const classes = useStyles();
  if (truncate) {
    return (
      <>
        <Typography>
          {description.slice(0, maxCharsDisplay)}
          {description.length > maxCharsDisplay && '... '}
        </Typography>
        {description.length > maxCharsDisplay && (
          <Button color="primary" onClick={toggleDescription} className={classes.showMoreLessBtn}>
            {SHOW_FULL_INFORMATION}
          </Button>
        )}
      </>
    );
  }
  if (isCollapsible) {
    return (
      <>
        <Typography>{description}</Typography>
        <Button color="primary" onClick={toggleDescription} className={classes.showMoreLessBtn}>
          {SHOW_LESS_DESCRIPTION}
        </Button>
      </>
    );
  }

  return <Typography>{description}</Typography>;
};
export default CompanyDescription;
